module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/48ed62bb2875adc2cf9739588bb16c4b.png";